import styled from "styled-components";
import { Flex } from "@evergis/ui";

export const ChartTooltip = styled(Flex)`
  transform: translate(calc(-100% + 1rem), calc(-50% - 0.65rem));
  font-size: 0.5rem;
  box-sizing: border-box;
  position: relative;
  color: ${({ theme: { palette } }) => palette.background};
  padding: 0.375rem;
  background-color: ${({ theme: { palette } }) => palette.textPrimary};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  box-shadow: 0 0.1875rem 0.5rem ${({ theme: { palette } }) => palette.elementDark};
  opacity: 0.8;

  :before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0.8rem;
    transform: translate(0, 100%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4px 3px 0 3px;
    border-color: ${({ theme: { palette } }) => palette.textPrimary} transparent transparent transparent;
  }
`;

export const ChartLegendColor = styled.div<{ $color: string }>`
  width: 0.5rem;
  height: 0.5rem;
  background-color: ${({ $color }) => $color};
  border-radius: 0.125rem;
`;

export const ChartLegendValue = styled.div`
  opacity: 0.65;
`;

export const ChartTooltipRow = styled(Flex)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 0.25rem;
  line-height: 0;

  ${ChartLegendColor} {
    margin-right: 0.25rem;
  }
`;

export const ChartWrapperContainer = styled.div<{ column: boolean }>`
  position: relative;
  width: 100%;
`;
